<div class="sr-page">

  <!-- ── HEADER ─────────────────────────────────────────────── -->
  <div class="sr-header">
    <div class="sr-header__icon"><mat-icon>search</mat-icon></div>
    <div>
      <h1 class="sr-header__title">Buscador de ventas</h1>
      <p class="sr-header__sub">Busca facturas, albaranes, presupuestos y tickets por cualquier criterio</p>
    </div>
  </div>

  <!-- ── CUERPO ─────────────────────────────────────────────── -->
  <div class="sr-body">

    <!-- Panel de búsqueda -->
    <div class="sr-search-panel">
      <div class="sr-search-panel__head">
        <mat-icon>filter_list</mat-icon>
        <span>Filtros de búsqueda</span>
      </div>
      <div class="sr-search-panel__body">
        <form [formGroup]="searchForm" (ngSubmit)="search()">

          <div class="row g-3">
            <div class="col-12 col-md-6 col-lg-4">
              <app-input inputType="text" placeholder="Ej: FCT-2024-00123" formControlName="searchInput"></app-input>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <app-input inputType="text" placeholder="Nombre del cliente" formControlName="searchClient"></app-input>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <app-input inputType="text" placeholder="Ej: Reparación, Producto A…" formControlName="searchConcept"></app-input>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <app-input inputType="text" placeholder="Ej: FW123456C1403" formControlName="searchSerialNumber"></app-input>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha desde</mat-label>
                <mat-icon matPrefix>event</mat-icon>
                <input matInput [matDatepicker]="startPicker" formControlName="startDate">
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha hasta</mat-label>
                <mat-icon matPrefix>event</mat-icon>
                <input matInput [matDatepicker]="endPicker" formControlName="endDate">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
              </mat-form-field>
            </div>
          </div>

          <div class="sr-search-footer">
            <span class="sr-error" *ngIf="errorMessage && !searching">
              <mat-icon>error_outline</mat-icon>{{ errorMessage }}
            </span>
            <button mat-flat-button class="sr-btn-search" type="submit" [disabled]="searching">
              <mat-icon>search</mat-icon>
              {{ searching ? 'Buscando…' : 'Buscar' }}
            </button>
          </div>

        </form>
      </div>
    </div>

    <!-- Loading -->
    <div class="sr-loading" *ngIf="searching">
      <div class="sr-loading__dots"><span></span><span></span><span></span></div>
      <p class="sr-loading__text">Buscando documentos…</p>
    </div>

    <!-- Empty state -->
    <div class="cf-empty-state" *ngIf="hasSearched && !searching && invoices.length === 0">
      <mat-icon>find_in_page</mat-icon>
      <p class="cf-empty-state__title">Sin resultados</p>
      <p class="cf-empty-state__subtitle">{{ errorMessage || 'No se encontraron documentos con esos filtros' }}</p>
    </div>

    <!-- Resultados -->
    <div class="sr-results" *ngIf="!searching && invoices.length > 0">
      <p class="sr-results__count">
        <mat-icon>check_circle</mat-icon>
        {{ invoices.length }} documento{{ invoices.length !== 1 ? 's' : '' }} encontrado{{ invoices.length !== 1 ? 's' : '' }}
      </p>

      <div class="sr-result-card" *ngFor="let item of invoices; trackBy: trackByIndex">
        <div class="sr-result-card__header">

          <div class="sr-result-card__icon-wrap"
               [class.sr-result-card__icon--invoice]="item.invoiceNumber"
               [class.sr-result-card__icon--preinvoice]="item.preInvoiceNumber && !item.isDeliveryNote"
               [class.sr-result-card__icon--delivery]="item.isDeliveryNote"
               [class.sr-result-card__icon--ticket]="item.ticketNumber">
            <mat-icon *ngIf="item.invoiceNumber">receipt</mat-icon>
            <mat-icon *ngIf="item.preInvoiceNumber && !item.isDeliveryNote">description</mat-icon>
            <mat-icon *ngIf="item.isDeliveryNote">local_shipping</mat-icon>
            <mat-icon *ngIf="item.ticketNumber && !item.invoiceNumber && !item.preInvoiceNumber">local_activity</mat-icon>
          </div>

          <div class="sr-result-card__info">
            <p class="sr-result-card__type">
              <ng-container *ngIf="item.invoiceNumber">Factura</ng-container>
              <ng-container *ngIf="item.preInvoiceNumber && !item.isDeliveryNote">Presupuesto</ng-container>
              <ng-container *ngIf="item.isDeliveryNote">Albarán</ng-container>
              <ng-container *ngIf="item.ticketNumber && !item.invoiceNumber && !item.preInvoiceNumber">Ticket</ng-container>
            </p>
            <p class="sr-result-card__number">
              {{ item.invoiceNumber || item.preInvoiceNumber || item.ticketNumber || '—' }}
            </p>
          </div>

          <div class="sr-result-card__meta">
            <span class="sr-meta-item">
              <mat-icon>person</mat-icon>
              {{ item.receiverName || '—' }}
            </span>
            <span class="sr-meta-item" *ngIf="item.invoiceRelease || item.createdDate">
              <mat-icon>event</mat-icon>
              {{ (item.invoiceRelease || item.createdDate) | date:'dd/MM/yyyy' }}
            </span>
            <span class="sr-meta-item sr-meta-item--amount" *ngIf="item.total !== undefined || item.amount !== undefined">
              <mat-icon>attach_money</mat-icon>
              {{ (item.total ?? item.amount) | currency:'EUR':'symbol':'1.2-2' }}
            </span>
          </div>

          <button mat-flat-button class="sr-btn-download" (click)="downloadDocument(item)" matTooltip="Descargar PDF">
            <mat-icon>get_app</mat-icon> PDF
          </button>
        </div>

        <!-- Líneas del documento -->
        <div class="sr-result-card__lines" *ngIf="item.invoiceLines?.length > 0 || item.ticketLines?.length > 0">
          <p class="sr-lines-label">Conceptos</p>
          <div class="sr-lines-list">
            <span class="sr-line-item" *ngFor="let line of item.invoiceLines; trackBy: trackByIndex">{{ line.description }}</span>
            <span class="sr-line-item" *ngFor="let line of item.ticketLines; trackBy: trackByIndex">{{ line.product }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>
